var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{class:_vm.getClass(_vm.dataItem.emissionExpiry)},[_vm._v(" "+_vm._s(_vm.cellFunction(_vm.dataItem.emissionExpiry))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }